import { Injectable } from '@angular/core';
import { OrganizationService } from '../../../core/organizations/organization.service';
import { distinctUntilChanged, pluck } from 'rxjs';
import {
  GetMineOrdersGQL,
  GetMineOrdersQuery,
  GetMineOrdersQueryVariables,
  MineOrdersSubGQL,
  MineOrderUpdatedGQL,
  MinePrintsOrdersPlacedInLabGQL,
  MineProductsOrdersPlacedInLabGQL,
} from '../graphql';
import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class OrderSubscriptionService {
  constructor(
    private sub: MineOrdersSubGQL,
    private organizations: OrganizationService,
    private apollo: Apollo,
    private mineOrders: GetMineOrdersGQL,
    private minePrintsOrdersPlacedInLabGQL: MinePrintsOrdersPlacedInLabGQL,
    private mineProductsOrdersPlacedInLabGQL: MineProductsOrdersPlacedInLabGQL,
    private mineOrderUpdatedGQL: MineOrderUpdatedGQL,
  ) {}

  subToOrders() {
    this.organizations
      .getCurrentOrganization()
      .pipe(distinctUntilChanged())
      .subscribe((organizationId) => {
        this.minePrintsOrdersPlacedInLabGQL
          .subscribe({ variables: { organizationId } })
          .subscribe((v) => {
            console.log(v);
          });
        this.mineProductsOrdersPlacedInLabGQL
          .subscribe({ variables: { organizationId } })
          .subscribe((v) => {
            console.log(v);
          });
        this.sub
          .subscribe({ variables: { organizationId } })
          .pipe(pluck('data', 'newOrderAdded'))
          .subscribe((ev) => {
            console.log('NEW ORDER PLACED', ev);
            const variables: GetMineOrdersQueryVariables = {
              organizationId,
            };
            const config = {
              query: this.mineOrders.document,
              variables,
            };
            const res =
              this.apollo.client.readQuery<GetMineOrdersQuery>(config);
            if (res) {
              this.apollo.client.writeQuery({
                ...config,
                data: {
                  orders: {
                    ...res.orders,
                    orders: [ev, ...res.orders.orders],
                  },
                },
              });
            }
            const variables2: GetMineOrdersQueryVariables = {
              organizationId,
              context: ev.context,
              contextId: ev.contextId,
            };
            const res2 = this.apollo.client.readQuery<GetMineOrdersQuery>({
              ...config,
              variables: variables2,
            });
            if (res2) {
              this.apollo.client.writeQuery({
                query: this.mineOrders.document,
                variables: variables2,
                data: {
                  orders: {
                    ...res2.orders,
                    orders: [ev, ...res2.orders.orders],
                  },
                },
              });
            }
          });
        this.mineOrderUpdatedGQL
          .subscribe({ variables: { organizationId } })
          .subscribe();
      });
  }
}
